import { ChatBubbleLeftIcon } from '@heroicons/react/24/outline';

export default function WhatsAppButton() {
  const phoneNumber = '2348138576446'; // Replace with your customer care WhatsApp number
  const message = 'Hello, I have a question about a car listing!';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition-all z-40 flex items-center justify-center"
      aria-label="Chat with us on WhatsApp"
    >
      <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="h-6 w-6 sm:h-5 sm:w-5" />
    </a>
  );
}
